import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StorySpecialItem from "../../atoms/story-special-item";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";

const StoryGrid = ({ collection, metadata, accentColor = "#E5E2E3", loadMore = false }) => {
  const { name } = collection;
  let stories = get(collection, ["items"], [])
    .filter(item => item.type === "story")
    .map(item => item.story)
    .filter(story => getStoryHeadline(story) && story.url);
  return (
    <div className={`${styles["main-row"]} ${loadMore && styles["loadmore-template"]}`}>
      <div className={`${styles["outer-sec"]}`}>
        <div
          className={`${styles["base"]} nine-stories-main container ${loadMore && styles["loadmore-template"]}`}
          style={accentColor && { "--accent-color": accentColor }}
        >
          {!loadMore && <h2 className={styles["main-title"]}>{name}</h2>}
          <div className={styles["stack-grid"]}>
            {stories.splice(0, 6).map(story => (
              <StorySpecialItem key={story.id} story={story} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Collection = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  slug: PropTypes.string,
  readMoreText: PropTypes.string,
  items: PropTypes.shape()
});

StoryGrid.propTypes = {
  accentColor: PropTypes.string,
  loadMore: PropTypes.bool,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(Collection)
  }),
  metadata: PropTypes.shape({
    read_more_text: PropTypes.string
  })
};

export default StoryGrid;
